import { FormHelpers } from "utility/form-helpers"
import { validateInput } from "utility/form-validation"
import { CheckCircleHollowIcon, WarningIcon } from "../icons"
import { Toasts } from "./toasts"

export const MailingList = (target: HTMLFormElement) => {
  const el = {
    root: target,
    input: target.querySelector<HTMLInputElement>('input'),
    button: target.querySelector<HTMLButtonElement>('.button[type="submit"]')
  }

  const method = {

    init: () => {
      if (!el.input || !el.button) return
      el.root.addEventListener('submit', method.onSubmit)
    },

    onSubmit: (e: Event & { target: HTMLFormElement }) => {
      e.preventDefault()

      if (!el.input.value.length) return

      const isValidForm = validateInput({ input: el.input, showError: false })
      if (!isValidForm) {
        Toasts.addToast({
          title: 'Villa kom upp!',
          text: 'Netfang er ekki gilt.',
          icon: WarningIcon(),
        })
        return
      }

      FormHelpers.submitForm({
        form: e.target,
        buttons: [el.button],
        onSuccess: ({ message = '' }) => {
          el.input.value = ''
          Toasts.addToast({
            title: 'Skráning tókst!',
            text: message || 'Netfang þitt var skráð á póstlista okkar.',
            icon: CheckCircleHollowIcon(),
          })
        },
        onError: (message = '') => Toasts.addToast({
          title: 'Villa kom upp!',
          text: message || 'Úps, ekki tókst að skrá netfang þitt á póstlista okkar.',
          icon: WarningIcon(),
        }),
      })
    },
  }

  method.init()
}